import { tns } from 'tiny-slider/src/tiny-slider';
// this is not hearing the changes
class MediaSlider {
	constructor(el) {
		this.el = el;
		this.block = this.el.closest('.block-media');

		document.addEventListener('trustindex-feed-loader-ready', () => this.initCustomSlider());

		setTimeout(() => this.initCustomSlider(), 4000);
	}

	initCustomSlider() {
		const widget = this.el.querySelector('.ti-widget');
		if (!widget) return;

		const container = widget.querySelector('.ti-widget-layout');
		if (!container) return;

		const items = container.querySelectorAll('.ti-layout-item');
		if (!items.length) return;

		container.removeAttribute('style');
		items.forEach((el) => {
			el.removeAttribute('style');
		});

		this.el.style.position = 'relative';

		this.mediaSlider = tns({
			container: container,
			items: 1,
			slideBy: 1,
			center: true,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			swipeAngle: false,
			speed: 600,
			controls: true,
			nav: false,
			gutter: 20,
			loop: true,
			responsive: {
				641: { items: 2 },
				1025: { items: 3 },
			},
		});

		this.addVideoIcons(container);

		const observer = new MutationObserver(() => this.addVideoIcons(container));
		observer.observe(container, { childList: true, subtree: true });
	}

	addVideoIcons(container) {
		const cards = container.querySelectorAll('.ti-widget-card, .ti-layout-item');
		cards.forEach((card) => {
			const img = card.querySelector('img');
			if (!img) return;

			const isVideo =
				img.src.includes('/reel/') ||
				img.src.includes('video') ||
				card.dataset.cardType === '2';

			if (isVideo && !card.querySelector('.reel-icon')) {
				const icon = document.createElement('div');
				icon.className = 'reel-icon';
				card.style.position = 'relative';
				card.appendChild(icon);
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll('.block-media__slider');
	sliders.forEach((el) => new MediaSlider(el));
});

export default MediaSlider;
